import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import {
  ICommAutomobileApplication,
  initialCommAutomobileApplicationState,
} from "./commAutoApplication.types";

export const FETCH_COMM_AUTOMOBILE_APPLICATION_PROGRESS =
  "FETCH_COMM_AUTOMOBILE_APPLICATION_PROGRESS";
export const FETCH_COMM_AUTOMOBILE_APPLICATION_SUCCESSS =
  "FETCH_COMM_AUTOMOBILE_APPLICATION_SUCCESSS";
export const FETCH_COMM_AUTOMOBILE_APPLICATION_FAILED =
  "FETCH_COMM_AUTOMOBILE_APPLICATION_FAILED";

export const fetchCommAutomobileApplicationProgress = () =>
  action(FETCH_COMM_AUTOMOBILE_APPLICATION_PROGRESS);
export const fetchCommAutomobileApplicationSuccess = (
  data: ICommAutomobileApplication
) => action(FETCH_COMM_AUTOMOBILE_APPLICATION_SUCCESSS, { data });
export const fetchCommAutomobileApplicationFailed = () =>
  action(FETCH_COMM_AUTOMOBILE_APPLICATION_FAILED);

export const fetchCommAutomobileApplicationAsync =
  (
    customerPolicyId: number,
    incremental_number: number
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchCommAutomobileApplicationProgress());
      const res = await api.get(
        `/policy/get-commauto-automobile-application?customer_policy_id=${customerPolicyId}&column=incremental_number&value=${incremental_number}`
      );
      const data: ICommAutomobileApplication[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchCommAutomobileApplicationSuccess(data[0]));
      } else {
        dispatch(
          fetchCommAutomobileApplicationSuccess(
            initialCommAutomobileApplicationState["application"]
          )
        );
      }
    } catch (err: any) {
      dispatch(fetchCommAutomobileApplicationFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addCommAutomobileApllication =
  (
    data: ICommAutomobileApplication,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/policy/edit-commauto-automobile-application", {
        ...data,
      });
      onCallback(true);
      dispatch(
        showMessage({
          type: "success",
          message: "Application saved successfully!",
          displayAs: "snackbar",
        })
      );
      dispatch(fetchCommAutomobileApplicationSuccess(data));
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_COMM_AUTOMOBILE_APPLICATION_LIST_PROGRESS =
  "FETCH_COMM_AUTOMOBILE_APPLICATION_LIST_PROGRESS";
export const FETCH_COMM_AUTOMOBILE_APPLICATION_LIST_SUCCESS =
  "FETCH_COMM_AUTOMOBILE_APPLICATION_LIST_SUCCESS";
export const FETCH_COMM_AUTOMOBILE_APPLICATION_LIST_FAILED =
  "FETCH_COMM_AUTOMOBILE_APPLICATION_LIST_FAILED";

export const fetchCommAutomobileApplicationListProgress = () =>
  action(FETCH_COMM_AUTOMOBILE_APPLICATION_LIST_PROGRESS);

export const fetchCommAutomobileApplicationsListSuccess = (
  data: ICommAutomobileApplication[]
) =>
  action(FETCH_COMM_AUTOMOBILE_APPLICATION_LIST_SUCCESS, {
    data,
  });
export const fetchCommAutomobileApplicationListFailed = () =>
  action(FETCH_COMM_AUTOMOBILE_APPLICATION_LIST_FAILED);

export const fetchCommAutomobileApplicationListAsync =
  (customerPolicyId: number): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchCommAutomobileApplicationListProgress());
      const res = await api.get(
        `/policy/get-commauto-automobile-application?customer_policy_id=${customerPolicyId}`
      );
      const data: ICommAutomobileApplication[] = res.data.data;
      dispatch(fetchCommAutomobileApplicationsListSuccess(data));
    } catch (err: any) {
      dispatch(fetchCommAutomobileApplicationListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const CLEAR_COMM_AUTOMOBILE_APPLICATION_STATE =
  "CLEAR_COMM_AUTOMOBILE_APPLICATION_STATE";

export const clearCommAutomobileApplicationState = () =>
  action(CLEAR_COMM_AUTOMOBILE_APPLICATION_STATE);
